module.exports = fox._r("images/gifts/gift-4.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/gifts/gift-4.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/gifts/gift-4.png
// module id = 205
// module chunks = 4